<template>
  <section class="story0302">

    <div class="story0302--con">
      <div class="con--inner">

        

        <!-- <div class="story0302--txt"> -->

          <!-- <img src="@/assets/images/brandstory/logo_white@2x.png" class="story0302--logo mb-2" alt="botalab">
          <p class="mb-2">
            누구나 건강한 삶을 꿈꾸고 있습니다.
          </p>
          <p class="mb-2">
            지금보다 더 나은 삶, 만족도 높은 삶을 지향하는 우리는 <br>
            몸 속에서부터 차오르는 빛과 <br>
            에너지를 만들기 위해 매일을 가꿔야 합니다.
          </p>
          <p class="mb-2">
            어쩌면 우리가 더 바라는 건 특별함이 아닌 소소한 일상의 기쁨일지 모릅니다. <br>
            우리 마음에 문득 들어오는 힘듦은 조금씩 덜어내고 좋은 것들을 담아보세요.
          </p>
          <p class="mb-2">
            가벼운 명상으로 나만의 고요한 순간을 만들고 <br>
            마음이 지친 어느 날은 나를 위한 건강한 음식을 만들고 <br>
            사랑하는 사람들과 함께하는 모든 순간을 느끼고 즐기며 <br>
            하루하루 매 순간을 밝은 생각들로 가득 채우세요.
          </p>
          <p class="mb-2">
            더욱 생기 있고 활력 넘치는 일상을 위해 <br>
            건강한 식품과 운동으로 매일을 채워 나가고 있는 당신은 <br>
            어느새 나 자신을 아끼고 가꾸며, <br>
            빛나는 현재를 살아가고 있을 것입니다.
          </p>
          <p>
            더욱 건강하고 아름다운 순간, <br>
            현재를 살아가는 당신 곁에 <br>
            라이프닝이 함께합니다.
          </p> -->

        <!-- </div> -->

      </div>

      <div class="container s7Con">
        <div class="swiper-container slide0803">
          <div class="swiper-wrapper slide08--wrapper">
            <div class="swiper-slide slide08--txt white">
              <h2 class="slide08--tit noMl">We may see Lifening.</h2>
              <div class="slide08--wrap tline">
                <p class="slide08--p">
                  빛나는 사람 = 건강한 사람.
                </p>
                <p class="slide08--p">
                  건강한 사람은 말과 행동이 견고하고 안정됩니다. <br>
                  건강한 사람은 소중한 관계를 지킬 줄 압니다. <br>
                  건강한 사람은 불안한 세상에서 희망을 봅니다. <br>
                  건강한 사람은 나를 이루는 세계에 <br>
                  밝은 빛을 더합니다.
                </p>
                <p class="slide08--p">
                  내 곁의 사람들이 행복할 수 있는 에너지. <br>
                  나를 둘러싼 세계를 더욱 빛내는 에너지. <br>
                  그런 에너지를 만들 수 있도록 <br>
                  당신의 하루를 디자인하세요. <br>
                  Lifening이 함께 합니다.
                </p>
              </div>
            </div>
            <div class="swiper-slide slide08--txt white">
              <h2 class="slide08--tit noMl">We can start Lifening.</h2>
              <div class="slide08--wrap tline">
                <p class="slide08--p">
                  나의 에너지는 나만이 가꿉니다. <br>
                  나의 빛은 나만이 지킵니다. <br>
                  나의 몸은 나의 행동을 기다립니다. <br>
                  내 몸의 변화로 세상의 변화를 이길 수 있습니다.
                </p>
                <p class="slide08--p">
                  살아가고 있으므로 돌아봐야 합니다. <br>
                  살아가고 있으므로 돌봐야 합니다. <br>
                  우리는 지금밖에 살 수 없고, 지금밖에 변화할 수 없습니다.
                </p>
                <p class="slide08--p">
                  언제나, 언제까지나 '이 순간'일 뿐입니다. <br>
                  빛나는 사람은 현재를 위한 지금의 선택을 합니다. <br>
                  Lifening은, 변화를 이길 행동을 선택하는 순간입니다. <br>
                  오롯이 서서 존재하는 하루입니다.
                </p>
                <p class="slide08--p">
                  자신이 쌓아온 내부의 빛으로 물드는 매일입니다. <br>
                  삶의 현재진행형, 바로 그것입니다.
                </p>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import Swiper from '@/assets/plugins/swiper.min';
import '@/assets/plugins/swiper.min.css';
export default {
  name: 'Section3',
  data(){
    return{
      slide07: Swiper,
    }
  },
  mounted() {
    this.slide07 = new Swiper('.slide0803', {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      speed: 500,
      slidesPerView: 2,
      // height: 600,
      effect: 'slide',
      // loop: true,
      // autoplay: {
        //   delay: 3000,
      //   disableOnInteraction: false,
      // },
      pagination: {
        el: '.swiper-pagination',
        // type: 'bullets',
      },
      breakpoints: {
        600: {
          slidesPerView: 1,
          // pagination: false,
          // navigation: false,
          height: '100vh',
          // scrollbar: {
          //   el: '.slide1 .btn_controllLR .swiper-scrollbar',
          //   hide: false,
          //   dragSize: 'auto',
          // },
        },
      },
    });
  },
};
</script>
